module.exports = __webpack_public_path__ + "img/img_82837_0_53.6757faeb.png";